'use strict';

var customUtil = require('./customUtil');

$('#live-shop-info button').on('click', function () {
    var liveShopStreamKey = window.SitePreferences.LIVE_SHOP_STREAM_KEY;
    var liveElement = document.getElementById('live-element');
    $(liveElement).empty();
    // Mount the player to the div#live-element in our html
    // eslint-disable-next-line no-undef
    var embedPlayer = live.elements.embed();
    embedPlayer.mount(liveElement, {
        // Channel ID should be passed within an object, i.e. the second parameter for the mount method.
        channelId: liveShopStreamKey
    });

    if (customUtil.isMobile()) {
        $('#live-shop-popup .modal-dialog').removeClass('modal-dialog-centered');
    } else {
        $('#live-shop-popup .modal-dialog').addClass('modal-dialog-centered');
    }

    $('div[id="live-shop-popup"]').modal();
});

$(document).on('click', '.live-shop-container #past-content-list button, .live-shop-container #past-content-list .video-image img', function () {
    var video = document.getElementById('vodVideo');
    var $li = $(this).closest('li');
    var url = $(this).closest('.list-item.video').data('url');

    var videoId = $li.find('.list-item.video').data('id');
    var title = $li.find('.past-video-details .title').text();

    if (url === undefined) {
        url = $(this).closest('li').find('.list-item.video').data('url');
    }
    if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = url;
        // eslint-disable-next-line no-undef
    } else if (Hls.isSupported()) {
        // eslint-disable-next-line no-undef
        var hls = new Hls();

        // hls.on(Hls.Events.MANIFEST_PARSED, function() {
        //     setTimeout(function() {
        //         $('#vodVideo')[0].load();
        //     }, 1000);
        // });

        hls.loadSource(url);
        hls.attachMedia(video);
    }

    if (customUtil.isMobile()) {
        $('#live-shop-past-content .modal-dialog').removeClass('modal-dialog-centered');
    } else {
        $('#live-shop-past-content .modal-dialog').addClass('modal-dialog-centered');
    }

    video.dataset.id = videoId;
    video.dataset.title = title;

    $('div[id="live-shop-past-content"]').modal();
});

$(document).on('click', '.list-item-products .view-all-link a, .list-item-products .view-more-count a', function (e) {
    e.preventDefault();
    if ($(this).hasClass('disabled')) {
        return;
    }
    var $featuredProductsList = $('#live-shop-featured-products .list-item-product');
    var videoId = $(this).closest('.list-item-products').siblings('.list-item.video').data('id');
    // eslint-disable-next-line no-undef
    var featuredProductsList = live.elements.vod.getVideoFeaturedProducts({ videoId: videoId });
    featuredProductsList.then(function (products) {
        if (products.length > 0) {
            $featuredProductsList.empty();
            $.each(products, function (index, product) {
                var $featuredProduct = $('<li>\n' +
                    '                                <div class="prod-image">\n' +
                    '                                   <a href="' + window.Urls.productUrlPlaceHolder + '">\n' +
                    '                                        <img src="' + product.product.preview_image.image.small + '" width="100" alt="' + product.product.title + '" title="' + product.product.title + '" />\n' +
                    '                                   </a>\n' +
                    '                                </div>\n' +
                    '                                <div>\n' +
                    '                                    <p>' + product.product.title + '</p>\n' +
                    '                                </div>\n' +
                    '                            </li>');
                $featuredProduct.find('a').attr('href', $featuredProduct.find('a').attr('href').replace('PRODUCT-ID', product.product.external_id));
                $featuredProductsList.append($featuredProduct);
            });
            $('div[id="live-shop-featured-products"]').modal();
        }
    });
});

$('div[id="live-shop-past-content"], div[id="live-shop-featured-products"]').on('hidden.bs.modal', function () {
    var video = document.querySelector('#vodVideo');
    video.pause();
    video.currentTime = 0;
});

function initVideoEvents() {
    var $PBJoAuthToken;
    var $PBJIframeURL;
    var $pageURL = window.location.href.toLowerCase();

    if ($pageURL.indexOf('staging') !== -1) {
        $PBJIframeURL = 'https://aliceandolivia.demo.pbj.live/shopping'; // STAGING
    } else  if ($pageURL.indexOf('development') !== -1) {
        $PBJIframeURL = 'https://aliceandolivia.demo.pbj.live/shopping'; // DEVELOPMENT
    } else if ($pageURL.indexOf('dev01') !== -1) {
        $PBJIframeURL = 'https://themes.dev.pbj.live/shopping'; // DEV
    } else {
        $PBJIframeURL = 'https://aliceandolivia.pbj.live/shopping'; // PRODUCTION
    }

    var $OCAPIHost = window.location.host;
    var $DWHost = 'https://' + $OCAPIHost + '/s/aando';
    var $OCAPIShopURL = $DWHost + '/dw/shop/v21_3/';
    var $DWCartURL = $DWHost + '/cart';
    var $PBJCookieKey = '$PBJLastCookieRefresh';
    var $PBJCookieRefreshRate = 10 * 60; // seconds

    function sendOCAPIRequest(method, url, headers = {}, data = {}, callback) {
        return new Promise(function(resolve, reject) {
            var xmlhttp = new XMLHttpRequest();   // new HttpRequest instance
            xmlhttp.open(method, $OCAPIShopURL + url + (url.indexOf('?') >= 0 ? '&' : '?') + 'client_id=4b690fe5-04d4-46fd-8fca-230a46f86f58&siteId=aando');
            Object.keys(headers).map(function(headerName) {
                xmlhttp.setRequestHeader(headerName, headers[headerName])
            })
            xmlhttp.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            if ($PBJoAuthToken) {
                xmlhttp.setRequestHeader('Authorization', 'Bearer ' + $PBJoAuthToken);
            }

            xmlhttp.onreadystatechange = function() {
                if (this.readyState >= 4) {
                    if (this.status >= 300) {
                        reject(this)
                    }
                    else {
                        resolve(this)
                    }
                }
            }
            xmlhttp.send(JSON.stringify(data));
        })
    }

    function toJSONResponse(request) {
        return JSON.parse(request.responseText)
    }

    const is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
    const is_safari = navigator.userAgent.indexOf('Safari') > -1;

    function isSafariBrowser(){
        if (is_safari){
            if (is_chrome)  // Chrome seems to have both Chrome and Safari userAgents
                return false;
            else
                return true;
        }
        return false;
    }

    function isIOS() {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    }

    function getCurrentUnix() {
        return (Math.floor(Date.now() / 1000))
    }

    function didRefreshCookies() {
        const lastTime = window.localStorage.getItem($PBJCookieKey) || 0

        // After 5 minutes we just do the same again
        if ((getCurrentUnix() - lastTime) > $PBJCookieRefreshRate) {
            return false
        }

        return true
    }

    function resizeLiveIframe() {
        var height = window.innerHeight - $('#pbj-iframe-wrapper').offset().top;
        $('#pbj-iframe-container').css('height', height);
    }

    async function injectIframe() {
        var authResponse;

        try {
            // Try to log in regularly
            const customerAuthRequest = await sendOCAPIRequest('POST', 'customers/auth', {}, { 'type': 'session' });
            authResponse = JSON.parse(customerAuthRequest.responseText);
            $PBJoAuthToken = customerAuthRequest.getResponseHeader('Authorization').replace(/^Bearer\s/, '');
        } catch {
            // Something seems off.. move user to guest auth
            const guestAuthRequest = await sendOCAPIRequest('POST', 'customers/auth', {}, { 'type': 'guest' });
            $PBJoAuthToken = guestAuthRequest.getResponseHeader('Authorization').replace(/^Bearer\s/, '');

            window.location.reload();
        }

        const customerBaskets = await sendOCAPIRequest('GET', 'customers/' + authResponse.customer_id + '/baskets').then(toJSONResponse)

        if (!customerBaskets.baskets) {
            await sendOCAPIRequest('POST', 'baskets', {}).then(toJSONResponse);
        }

        await sendOCAPIRequest('GET', 'customers/' + authResponse.customer_id + '/payment_instruments').then(toJSONResponse);

        if (isSafariBrowser() && !didRefreshCookies()) {
            // Safari's cookies are all messed up, once we reload the browser once
            // cookies set by /sessions are going to be active
            window.localStorage.setItem($PBJCookieKey, getCurrentUnix())
            window.location.reload()
            return
        }

        $('#pbj-shopping').attr('src', $PBJIframeURL + '?ocapi_token=' + $PBJoAuthToken + '&customer_id=' + authResponse.customer_id + '&checkout_url=' + encodeURIComponent($DWCartURL));

        resizeLiveIframe();
    }

    injectIframe();

    $(window).on('resize', resizeLiveIframe);

    $(document).on('click', '#pbj-live-player-fullscreen-btn', function () {
        var liveWrapperEl = $('#pbj-iframe-wrapper');
        var iframe = $('#pbj-shopping');

        if ($(this).data('toggle') === 'fullscreen') {
            iframe.css('position', 'static');
            $(this).data('toggle', '');
            $(this).css('position', 'absolute');
            liveWrapperEl.css('z-index', 99);
            $('body').css('overflow', 'auto');
        } else {
            iframe.css({
                'bottom': '100px',
                'left': '0',
                'position': 'fixed',
                'right': '0',
                'top': '0'
            });
            $(this).data('toggle', 'fullscreen');
            $(this).css('position', 'fixed');
            liveWrapperEl.css('z-index', 999);
            $('body').css('overflow', 'hidden');
        }
    });
}

$(document).ready(function() {
    if ($('#pbj-iframe-wrapper').length) {
        initVideoEvents();
    }

    //Query video element
    var video = document.querySelector('video');

    // Enable video tracking
    video.onplaying = function(e) {
        if (typeof heap === 'undefined' || heap == undefined) {
            return;
        }
        heap.track('Video Played', {
            video_id: video.dataset.id,
            video_title: video.dataset.title,
            video_duration: video.duration
        });
    };

    video.onpause = function(e) {
        if (typeof heap === 'undefined' || heap == undefined) {
            return;
        }
        heap.track('Video Paused', {
            video_id: video.dataset.id,
            video_title: video.dataset.title,
            video_duration: video.duration,
            video_curTime: video.currentTime
        });
    };

    video.onended = function(e) {
        if (typeof heap === 'undefined' || heap == undefined) {
            return;
        }
        heap.track('Video Ended', {
            video_id: video.dataset.id,
            video_title: video.dataset.title,
            video_duration: video.duration,
            video_curTime: video.currentTime
        });
    };
});
